<template>
    <div>123123123123</div>
</template>
<script src="http://res.wx.qq.com/open/js/jweixin-1.0.0.js"></script>
<script>
import wxShare from "../libs/wxShare";
import { getWechatConfig } from "@api/public";
export default {
    name: "not",
    data() {
        return {};
    },
    methods: {
        sharePeng() {
            getWechatConfig().then((res) => {
                var href = "http://app.shangpinbaoshi.com";
                console.log("22223333=>", res);
                var shareData = {
                    title: "12312", // 分享标题
                    desc: "1231", // 分享描述
                    link: href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl:
                        "http://qiniu.shangpinbaoshi.com/7c479202102210915486019.jpg", // 分享图标
                };
                var config = res.data;
                // wxShare(config, shareData, () => {
                //     alert("123123123123");
                // });
                wx.ready(function() {
                    console.log("ready执行");
                    wx.config({
                        debug: false,
                        appId: config.appId,
                        timestamp: config.timestamp,
                        nonceStr: config.nonceStr,
                        signature: config.signature,
                        jsApiList: [
                            "onMenuShareAppMessage",
                            "updateAppMessageShareData",
                            "onMenuShareTimeline",
                            "updateTimelineShareData",
                        ],
                    });
                    console.log("config=>",config)
                    console.log("shareData=>",shareData)
                     wx.onMenuShareAppMessage({
                        title: shareData.title, // 分享标题
                        link: shareData.link, // 分享链接,将当前登录用户转为puid,以便于发展下线
                        imgUrl: shareData.imgUrl, // 分享图标
                        success: function() {
                            alert("朋友分享成功");
                        },
                        cancel: function() {
                            // 用户取消分享后执行的回调函数
                            alert("fffff");
                        },
                    });
                     wx.updateAppMessageShareData({
                        title: shareData.title, // 分享标题
                        link: shareData.link, // 分享链接,将当前登录用户转为puid,以便于发展下线
                        imgUrl: shareData.imgUrl, // 分享图标
                        success: function() {
                            alert("朋友分享成功");
                        },
                        cancel: function() {
                            // 用户取消分享后执行的回调函数
                            alert("fffff");
                        },
                    });
                    wx.onMenuShareTimeline({
                        title: shareData.title, // 分享标题
                        link: shareData.link, // 分享链接,将当前登录用户转为puid,以便于发展下线
                        imgUrl: shareData.imgUrl, // 分享图标
                        success: function() {
                            alert("朋友圈分享成功");
                        },
                        cancel: function() {
                            // 用户取消分享后执行的回调函数
                            alert("fffff");
                        },
                    });
                    wx.updateTimelineShareData({
                        title: shareData.title, // 分享标题
                        link: shareData.link, // 分享链接,将当前登录用户转为puid,以便于发展下线
                        imgUrl: shareData.imgUrl, // 分享图标
                        success: function() {
                            alert("朋友圈分享成功");
                        },
                        cancel: function() {
                            // 用户取消分享后执行的回调函数
                            alert("fffff");
                        },
                    });
                    wx.error(function(res) {
                        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                        alert("errorMSG:" + res);
                    });
                });
            });
        },
    },
    mounted() {
        this.sharePeng();
    },
};
</script>
